import { Box } from '@mui/material';
import { getPortfolios } from 'lib/api/integrations/digitalSignature';
import CenteredCircularProgress from 'lib/designSystem/CircularProgress';
import HeaderWithActions from 'lib/designSystem/HeaderWithActions';
import TableWithPagination from 'lib/designSystem/TableWithPagination';
import { errorHandler } from 'lib/functions/errors';
import { Portfolio } from 'lib/types/models';
import { Pagination } from 'lib/types/shared';
import PortfolioModal from 'pages/BusinessProfile/Contracts/Portfolios/Components/PortfolioModal';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'services/redux/store';

const BASE_PAGINATION = {
  page: 1,
  pageSize: 10,
  total: 0,
  totalPages: 0,
};

const Portfolios = () => {
  const dispatch = useDispatch();
  const user = useSelector((state: RootState) => state.auth.user);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState<Pagination>(BASE_PAGINATION);
  const [portfolios, setPortfolios] = useState<Portfolio[]>([]);
  const [portfolio, setPortfolio] = useState<Portfolio | null>(null);
  const [openPortfolioModal, setOpenPortfolioModal] = useState(false);

  const fetchPortfolios = async ({
    page,
    pageSize,
  }: {
    page: number;
    pageSize: number;
  }) => {
    try {
      setLoading(true);
      const businessIdentifier = user?.businessIdentifier;
      const query = `page=${page}&pageSize=${pageSize}&businessIdentifier=${businessIdentifier}`;
      if (!user?.businessIdentifier) return;
      const response = await getPortfolios(dispatch, query);
      setPortfolios(response.data);
      setPagination(response.pagination);
    } catch (error) {
      errorHandler(dispatch, error);
    } finally {
      setLoading(false);
    }
  };

  const handleClickRow = (id: string) => {
    setOpenPortfolioModal(true);
    setPortfolio(portfolios.find((p) => p.id === id) || null);
  };

  const tableHeaders = [
    { label: 'Título', key: 'title', type: 'text' },
    { label: 'Estado', key: 'status', type: 'status-chip' },
    { label: 'Operación', key: 'requestType', type: 'text' },
    { label: 'ID operación', key: 'requestId', type: 'text' },
    { label: 'Cantidad de Firmantes', key: 'signersQuantity', type: 'text' },
    { label: 'Cantidad de Documentos', key: 'documentsQuantity', type: 'text' },
    { label: 'Fecha de Creación', key: 'createdAt', type: 'date' },
    { label: 'Fecha de Actualización', key: 'updatedAt', type: 'date' },
    { label: 'Válido hasta', key: 'validUntil', type: 'date' },
  ];

  useEffect(() => {
    void fetchPortfolios({ page: 1, pageSize: 10 });
  }, []);

  if (loading) return <CenteredCircularProgress />;

  return (
    <>
      <Box mt={2}>
        <HeaderWithActions
          title="Aca podras ver una lista con los portafolios de tu empresa."
          variant="body1"
          buttons={[]}
          type="subHeader"
        />
        <TableWithPagination
          data={portfolios}
          setData={setPortfolios}
          dataHeaders={tableHeaders}
          showActions
          pagination={pagination}
          setPagination={setPagination}
          searchData={fetchPortfolios}
          setLoading={setLoading}
          handleClickRow={handleClickRow}
          exportToFile="xlsx"
          exportComplete
          lastElement
        />
      </Box>
      <PortfolioModal
        open={openPortfolioModal}
        onClose={() => setOpenPortfolioModal(false)}
        portfolio={portfolio}
        onPortfolioUpdated={() =>
          void fetchPortfolios({ page: 1, pageSize: 10 })
        }
        pruffConnect
      />
    </>
  );
};

export default Portfolios;
